var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"block mx-2",attrs:{"to":_vm.link}},[_c('img',{staticClass:"h-4 w-4 opacity-50 hover:opacity-100",attrs:{"src":"/icons/actions/see.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }